export enum enumManualQuoteState {
  NEW,
  HANDLING,
  QUOTED,
  DENIED,
}
